"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.JUPYTER_WIDGETS_VERSION = '1.1.0';
exports.PROTOCOL_VERSION = '2.0.0';
